import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';
import { Integration } from '../../types/types'
import { integrationList } from './apiIntegrationsAPI';

export interface ApiIntegrationListState {
  api_integrations: Integration[] | null;
  status: 'idle' | 'loading' | 'failed';
}

const initialState: ApiIntegrationListState = {
  api_integrations: null,
  status: 'idle',
}

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const loadIntegrationsAsync = createAsyncThunk(
  'api_integration/fetch',
  async () => {
    const response = await integrationList();
    // The value we return becomes the `fulfilled` action payload
    console.log("loadIntegrationsAsync", response)
    return response.data;
  }
);

export const apiIntegrationSlice = createSlice({
  name: 'api_integration',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clear: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      console.log("clear")
      state.api_integrations = []
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadIntegrationsAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(loadIntegrationsAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.api_integrations = action.payload.results
      })
      .addCase(loadIntegrationsAsync.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export const { clear } = apiIntegrationSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
export const selectApiIntegrations = (state: RootState) => state.api_integration.api_integrations;
export const selectStatus = (state: RootState) => state.api_integration.status;

export default apiIntegrationSlice.reducer;
